/**
 * Get value of an object property/path even if it's nested
 */
export function getValueByPath(obj, path) {
  const value = path.split('.').reduce((o, i) => o[i], obj);
  return value;
}

/**
* Extension of indexOf method by equality function if specified
*/
export function indexOf(array, obj, fn) {
  if (!array) return -1;

  if (!fn || typeof fn !== 'function') return array.indexOf(obj);

  for (let i = 0; i < array.length; i++) {
    if (fn(array[i], obj)) {
      return i;
    }
  }

  return -1;
}

/**
* Mobile detection
* https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
*/
export const isMobile = {
  Android() {
    return (
      typeof window !== 'undefined'
      && window.navigator.userAgent.match(/Android/i)
    );
  },
  BlackBerry() {
    return (
      typeof window !== 'undefined'
      && window.navigator.userAgent.match(/BlackBerry/i)
    );
  },
  iOS() {
    return (
      typeof window !== 'undefined'
      && window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
    );
  },
  Opera() {
    return (
      typeof window !== 'undefined'
      && window.navigator.userAgent.match(/Opera Mini/i)
    );
  },
  Windows() {
    return (
      typeof window !== 'undefined'
      && window.navigator.userAgent.match(/IEMobile/i)
    );
  },
  any() {
    return (
      isMobile.Android()
      || isMobile.BlackBerry()
      || isMobile.iOS()
      || isMobile.Opera()
      || isMobile.Windows()
    );
  },
};

export function removeElement(el) {
  if (typeof el.remove !== 'undefined') {
    el.remove();
  } else if (typeof el.parentNode !== 'undefined') {
    el.parentNode.removeChild(el);
  }
}

/**
* Escape regex characters
* http://stackoverflow.com/a/6969486
*/
export function escapeRegExpChars(value) {
  if (!value) return value;

  // eslint-disable-next-line
  return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

/**
 * Decide if the text should be a light or dark color.
 */

export function findTextContrastingColor(hexValue) {
  const dark = 'text-gray-900';
  const light = 'text-gray-100';
  let color = hexValue;

  color = color.replace('#', '');
  if (color.length === 3) {
    color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2);
  } else if (color.length !== 6) {
    throw (`Invalid hex color: ${color}`);
  }

  const rgb = [];
  for (let i = 0; i <= 2; i++) { rgb[i] = parseInt(color.substr(i * 2, 2), 16); }

  const luma = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]); // SMPTE C, Rec. 709 weightings
  return (luma >= 165) ? dark : light;
}